// extracted by mini-css-extract-plugin
export default {"cls1":"SidebarSection-cls1_xoq","cls2":"SidebarSection-cls2_FGF SidebarSection-cls1_xoq"};